import '../css/Fields.css'
import Photo from './Sidebar/Photo'
import Name from './Sidebar/Name'
import JobTitle from './Sidebar/JobTitle'
import Description from './Sidebar/Description'
import Contact from './Sidebar/Contact'
import Email from './Sidebar/Email'
import Experience from './Sidebar/Experience'
import Skill from './Sidebar/Skill'
import Reference from './Sidebar/Reference'
import Projects from './Sidebar/Projects'
import Education from './Sidebar/Education'

function Fields({ field, fieldHandler }) {
   function handleValue(value, key) {
      fieldHandler(prev => ({ ...prev, [key]: value }))
   }

   function setHandler(e, key) {
      const { id, value } = e.target
      fieldHandler(prev => ({
         ...prev,
         [key]: prev[key].map(n => (n.id == id ? { ...n, value } : n)),
      }))
   }

   function addHandler(key) {
      fieldHandler(prev => {
         const list = prev[key]
         return {
            ...prev,
            [key]: [...list, { id: list.at(-1).id + 1, value: '' }],
         }
      })
   }

   const listProps = { field, addHandler, setHandler }

   return (
      <>
         <Photo preview={field.photo} handleValue={handleValue} />

         <div style={{ paddingTop: '.5rem' }}>
            <div className="section-label">Identity</div>
            <Name value={field.fullname} handleValue={handleValue} />
            <JobTitle value={field.jobtitle} handleValue={handleValue} />
            <Description value={field.description} handleValue={handleValue} />
            <Contact value={field.contact} handleValue={handleValue} />
            <Email value={field.email} handleValue={handleValue} />
         </div>

         <div style={{ paddingTop: '.25rem' }}>
            <div className="section-label">Background</div>
            <Experience {...listProps} />
            <Skill {...listProps} />
            <Reference {...listProps} />
            <Projects {...listProps} />
         </div>

         <div style={{ paddingTop: '.25rem' }}>
            <div className="section-label">Education</div>
            <Education field={field} fieldHandler={fieldHandler} />
         </div>
      </>
   )
}

export default Fields
